class BeeVideo
{

   constructor(containerId, videoType, videoId, settings)
   {
      this.containerId = containerId;
      this.videoType = videoType;
      this.videoId = videoId;
      this.settings = settings;

      this.init();
   }

   init = () =>
   {
      if (this.videoType === 'youtube')
      {
         this.initializeYouTube();
      } else if(this.videoType === 'vimeo')
      {
         this.initializeVimeo();
      }

      this.bindEvents();
   }

   onYouTubePlayerReady = (event) =>
   {

      if( this.settings.autoplay === true )
      {
         event.target.mute();
         event.target.playVideo();
      }
   }

   buildYTVideo = async () => 
   {
      const _self = this;
      let player;

      const container = document.getElementById(this.containerId);

      if (container)
      {
         player = new YT.Player(container, {
            height: '540',
            width: '960',
            videoId: _self.videoId,
            playerVars: {
               enablejsapi: 1,
               cc_load_policy: 0,
               origin: window.location.href,
               playsinline: 1,
               fs: 0,
               loop: _self.settings.loop === 'true' ? 1 : 0,
               controls: _self.settings.controls === 'true' ? 1 : 0,
               iv_load_policy: 3,
               modestbranding: 1,
               rel: 0,
               showinfo: 0,
               playlist: _self.videoId
            },
            events: {
               'onReady': (event) => _self.onYouTubePlayerReady(event)
            }
         });
      }
   }

   buildVimeoVideo = async () =>
   {
      const _self = this;
      let VimeoPlayer;

      const options = {
         autoplay: _self.settings.autoplay,
         byline: false,
         controls: _self.settings.controls,
         loop: _self.settings.loop,
         muted: true,
         playsinline: true,
         responsive: false,
         title: false
      }
      VimeoPlayer = new Vimeo.Player(this.containerId, options);
      
      VimeoPlayer.setVolume(0);
      VimeoPlayer.play();
   }

   setSize = () =>
   {
      return;
      const container = document.getElementById(this.containerId);
      const wrapper = container.parentElement;
      const sectionContent = wrapper.parentElement;

      const wrapperWidth = wrapper.offsetWidth;
      const wrapperHeight = wrapper.offsetHeight;

      const sectionContentWidth = sectionContent.offsetWidth;
      const sectionContentHeight = sectionContent.offsetHeight;

      console.log('wrapperHeight', wrapperHeight);
      console.log('sectionContentHeight', sectionContentHeight);

      if( wrapperHeight > sectionContentHeight )
      {
         wrapper.style.cssText = `width: 100%; height: unset;`;
      }else{
         wrapper.style.cssText = `width: unset; height: 100%;`;
      }
   }

   initializeVimeo = () =>
   {
      const _self = this;
      const VimeoScriptId = 'bee-vimeo-script';

      if (!document.getElementById(VimeoScriptId))
      {
         const vimeoapi = document.createElement('script');
         vimeoapi.type = "text/javascript";
         vimeoapi.defer = "defer";
         vimeoapi.src = "https://player.vimeo.com/api/player.js";
         vimeoapi.onload = function ()
         {
            _self.buildVimeoVideo();
         }
         document.body.appendChild(vimeoapi);
      } else
      {
         _self.buildVimeoVideo();
      }
   }

   initializeYouTube = () =>
   {
      const _self = this;
      const YouTubeScriptId = 'bee-youtube-script';

      window.onYouTubeIframeAPIReady = function ()
      {
         _self.buildYTVideo();
      };

      if (!document.getElementById(YouTubeScriptId))
      {
         const ytapi = document.createElement('script');
         ytapi.type = "text/javascript";
         ytapi.id = YouTubeScriptId;
         ytapi.defer = "defer";
         ytapi.src = "https://www.youtube.com/iframe_api";
         document.body.appendChild(ytapi);
      } else
      {
         _self.buildYTVideo();
      }
   }

   bindEvents = () =>
   {
      const _self = this;

      window.addEventListener('resize', () => {
         _self.setSize();
      });

      _self.setSize();
   }

}